export interface CatCustomerRating {
  rating: string
  count: string
}

// Pin the original story as well as the route so replacement stories do not inherit the test.
const CAT_TRANSPORTATION_STORY_ID = 258009

export function isCatReviewPage(slug: string, storyId: number): boolean {
  return (
    slug === "cat-transportation" && storyId === CAT_TRANSPORTATION_STORY_ID
  )
}

export function parseCatCustomerRating(
  values: Record<string, string> | null,
): CatCustomerRating | null {
  const entries = Object.fromEntries(
    Object.entries(values ?? {}).map(([key, value]) => [key.trim(), value]),
  )
  const rating = entries.transportServiceRatings?.trim() ?? ""
  const count = entries.transportServiceReviews?.trim() ?? ""

  if (
    !/^\d+(?:\.\d+)?$/.test(rating) ||
    !/^(?:\d+|\d{1,3}(?:,\d{3})+)$/.test(count)
  ) {
    return null
  }

  const score = Number(rating)
  const total = Number(count.replaceAll(",", ""))

  if (score < 1 || score > 5 || !Number.isSafeInteger(total) || total <= 0) {
    return null
  }

  return { rating: String(score), count: total.toLocaleString("en-US") }
}
